import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router, NavigationExtras, NavigationEnd } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { retry, catchError , map} from "rxjs/operators";
import { Subject } from "rxjs";
import { Location } from "@angular/common";
import { ToastrManager } from "ng6-toastr-notifications"
// import * as moment from "moment";
import * as moment from 'moment-timezone';
import { environment } from "../../environments/environment";
declare var $:any;

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public currency:any='$';
  
  baseUrl =  `${environment.apiEndPoint}`;

  public giverSelectedUser = new Subject<any>();
  private currentUser: any = {};
  private subject = new Subject<any>();
  public currYear = new Date().getFullYear();
  public Language: any;
  public versions:any=localStorage.getItem('hva_version');
  public monthArray: any = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  public dayArray :any=['Sun','Mon','Tue','wed','Thu','Fri','Sat'];
  public defaultImage ='assets/images/avatars/default-avatar.jpg';

  // public Harray:any=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];
  // public Marray:any=[];
  // public Sarray:any=[];

  
  constructor(
    public http: HttpClient,
    private router: Router,
    private location: Location,
    public toastr: ToastrManager,
  ) {}

  // Http Options
  getHeaderLogin(type = 2) {
    var data:any = "";
    if (localStorage.getItem('hva_token')) {
      data ='Bearer '+  localStorage.getItem('hva_token');
    }
    if (type == 1) {
      return {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "X-Authorization": data,
          "device-type": "Browser",
          "device-token": "8749",
          "Version": "1.0.0",
          "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        }),
      };
    } else {
      return {
        headers: new HttpHeaders({
          "X-Authorization": data,
          "device-type": "Browser",
          "device-token": "8749",
          "Version": "1.0.0",
          "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        }),
      };
    }
  }
  // Http Options
  getHeadersLogin() {
    var data :any= "";
    if (localStorage.getItem('hva_token')) {
      data = 'Bearer '+ localStorage.getItem('hva_token');
    }
    return {
      headers: new HttpHeaders({
        //'Content-Type' : 'application/json, text/plain, */*',
        "X-Authorization":  data,
        "device-type": "Browser",
        "device-token": "8745",
        "Version": "1.0.0",
        "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        // 'lat':lat,
        // 'long':lang,
        // 'userid':currentUserId,
        // 'parentId':parentid,
        // 'timeZone':moment.tz.guess(),
        // 'timeZoneOffset':'',
        // 'role':role_id,
      }),
    };
  }

  setSubject(obj: any) {
    this.subject.next({ loginData: obj });
  }

  back() {
    this.location.back();
  }

  forword() {
    this.location.forward();
  }

  logOut() {
    var arr: any = [];
    const value: any = localStorage;    
    for (var i = 0; i < value.length; i++) {
      if (value.key(i).substring(0, 4) == 'hva_') {
        if (value.key(i) != 'hva_Remember') {
          arr.push(value.key(i));
        }
      }
    }
    for (var i = 0; i < arr.length; i++) {
      value.removeItem(arr[i]);
    }
  }

  /*
   * return data array
   */
  getSubject(): Observable<any> {
    return this.subject
      .asObservable()
      .pipe(retry(0), catchError(this.handleError))
  }

  // Common post api
  PostApis(data: any, url: any) {
    return this.http
      .post<any>(this.baseUrl + url, data, this.getHeaderLogin(1))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      if(response.version.master_version > this.versions){
        this.getAllMasterData();
      }
      return data;
    }))
  }

  PostApiFormData(data: any, url: any) {
    return this.http
      .post<any>(this.baseUrl + url, data, this.getHeaderLogin(2))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success == 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      if(response.version.master_version > this.versions){
        this.getAllMasterData();
      }
      return data;
    }))
  }

  // Common get api
  GetApi(url: any) {
    return this.http
      .get<any>(this.baseUrl + url, this.getHeaderLogin())
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success == 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      if(response.version.master_version > this.versions){
        this.getAllMasterData();
      }
      return data;
    }))
  }

  // Common get api
  DeleteApi(url: any) {
    return this.http
      .delete<any>(this.baseUrl + url, this.getHeaderLogin())
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      if(response.version.master_version > this.versions){
        this.getAllMasterData();
      }
      return data;
    }))
  }

  
  updateApi(data: any, url: any){
    return this.http
      .put<any>(this.baseUrl + url, data, this.getHeaderLogin(1))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
    
      return data;
    })) 
  }

  updateFormData(data: any, url: any) {
    return this.http
      .put<any>(this.baseUrl + url, data, this.getHeaderLogin(2))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success == 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
    
      return data;
    }))
  }

  updateApi1(data: any, url: any){
    return this.http
      .patch<any>(this.baseUrl + url, data, this.getHeaderLogin(1))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
    
      return data;
    })) 
  }

  updateFormData1(data: any, url: any) {
    return this.http
      .patch<any>(this.baseUrl + url, data, this.getHeaderLogin(2))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success == 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
    
      return data;
    }))
  }
  
  handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  // successAlert for fire toast/...
  successAlert(msg: any) {
    this.toastr.successToastr(msg, " ", {
      position: "top-right",
      toastTimeout:2000,
      maxShown:1
    });
  }

  warningAlert(msg: any) {
    this.toastr.warningToastr(msg, " ", {
      position: "top-right",
      toastTimeout:2000,
      maxShown:1
    });
  }

  // successAlert for fire toast/...
  dangerAlert(msg: any) {
    this.toastr.errorToastr(msg, " ", {
      position: "top-right",
      toastTimeout:2000,
      maxShown:1
    });
  }

  // convert date in (yyyy-mm-dd)
  ToDate(date: any) {
    var day = date.toString().slice(4, 15);
    var day1 = day.split(" ");
    var newmonth =
      this.monthArray.findIndex((rank: any) => rank === day1[0]) + 1;
    if (newmonth < 10) {
      newmonth = "0" + newmonth;
    }
    var dob = day1[2] + "-" + newmonth + "-" + day1[1];
    // var dob = day1[1] + "-" + newmonth + "-" + day1[2];

    return dob;
  }

  convertDate(date: any) {
    return moment(date).format("HH:mm DD MMMM YYYY");
  }

  checkStringLength(content: string) {
    return content == undefined ? false : true;
  }

  toTimestamp(strDate:any){
    var date = new Date(strDate);
    return date
  }

  ExpiryCheck(month:any,year:any){
    var today = new Date();
      var currYear = today.getFullYear();
      var months =  today.getMonth() + 1;
      // var newmonth:any;
      // if(months < 10){
      //   newmonth = '0'+ months;
      // }
      if((month < months && year <=  currYear )||  year <  currYear) {
        // this.dangerAlert('Expiry Month & Year is not valid')
        return false;
      } else{
        return 1;
      }
  }

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  TextOnly(event:any,type:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if(type==1){
      if (charCode == 64 ) {
        return false;
      }
    }else {
      
    }
    
    return true;
  }



  dateConvert(Dates:any,type:any){
    var event_date_start_utc1;
    event_date_start_utc1 = new Date(Dates*1000);
    var hours:any = event_date_start_utc1.getHours();
    var minutes:any = event_date_start_utc1.getMinutes();
    var newformat = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var date :any = event_date_start_utc1.getDate();
    if(date < 10){
      date = '0'+ date;
    }
    var month = event_date_start_utc1.getMonth();
    var months = month +1;
    var year = event_date_start_utc1.getFullYear();
    var day = event_date_start_utc1.getDay();
    if(type == 1){
      var newdate = date+'/'+months +'/'+ year;
      return  newdate;
    } else if(type == 2){
      var newdate = this.dayArray[day]+' '+this.monthArray[month] +' '+   date +' '+ year;
      return  newdate;
    } else  if(type == 3){
      var newdate = date+' '+this.monthArray[month] +' '+ year;
      return  newdate;
    } else if(type == 4){
      var jj = Dates.split('-');
      var kk = parseInt(jj[1])-1;
      var newdate = jj[0]+' '+this.monthArray[kk] +', '+ jj[2];
      return  newdate;
    } else {
      var newdate = date+'/'+months +'/'+ year +' ' + hours + ':' + minutes + ' ' + newformat;
      return  newdate;
    }
  }

  getAllMasterData(){
    const url = "/common-contents"; 
    this.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {        
        response.data.suitability.filter((el:any)=>{
          el.check = false;
        })
        localStorage.setItem('hva_materData',JSON.stringify(response.data));
      }
      localStorage.setItem('hva_version',response.version.master_version);
    }), (error) => { });
  }

  dataURLtoFile(dataurl: any, filename: any) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
  }

  get_parts_count(file: any) {
    let minimum_part_size;
    minimum_part_size = 6 * 1024 * 1024;
    let size = file.size;
    return Math.floor(size / minimum_part_size) + 1;
  }

  fixedPoint(data:any){
    return data.toFixed(2);
  }

  
  dateCon(date:any){
    var mm =date.split('T');
    return mm[0];
  }

      // function for word count
      wordCounter(){
        var value = $('#Description').val();
        var current = $('#current');
        if(value !=undefined){
          if (value.length == 0) {
            return;
          }
          //character counter
          current.text(value.length);
        }
        //words counter
        var regex = /\s+/gi;
        var wordCount = value.trim().replace(regex, ' ').split(' ').length;
       
      }

      sideIcon() { 
        if (localStorage.getItem('sidebar_selection')) {
          const sidebar_selection = localStorage.getItem('sidebar_selection');
          if (sidebar_selection == '1') {
            $('.wrapper').removeClass('toggled').removeClass('sidebar-hovered');
            localStorage.setItem('sidebar_selection', '0');
          } else {
            $('.wrapper').addClass('toggled');
            localStorage.setItem('sidebar_selection', '1');
          }  
        } else {
          $('.wrapper').addClass('toggled');
          localStorage.setItem('sidebar_selection', '1');
        }
      }
}

